const navigateTo = (path: string): void => {
  window.location.href = path;
};

const reloadCurrentPage = (): void => {
  window.location.reload();
};

const scrollTo = (y: number): void => {
  window.scrollTo({
    top: y,
    behavior: 'auto',
  });
};

const scrollIntoView = (element: HTMLElement): void => {
  element.scrollIntoView(false);
};

const offsetScrollIntoViewIfNeeded = (element: HTMLElement): void => {
  const header = document.getElementById('app-header') as HTMLElement;
  let headerOffset = 0;
  if (header) {
    headerOffset = header.offsetHeight;
  }
  const elementPosition = element.getBoundingClientRect().top;

  if (elementPosition >= headerOffset) {
    return;
  }

  const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

  window.scrollTo({
    top: offsetPosition,
    behavior: 'smooth',
  });
};

export {
  reloadCurrentPage,
  navigateTo,
  scrollTo,
  scrollIntoView,
  offsetScrollIntoViewIfNeeded,
};
